// Controls
import { BaseComponent } from "@ms/uno-controls/lib/local/controls/BaseComponent";
import { UnoLeftNavOption } from "./UnoLeftNavOption";
// Utilities
import React from "react";
import { FocusZone, FocusZoneDirection, getRTL } from "@fluentui/react";
import { css } from "@fluentui/utilities/lib/css";
// Styles
import { getUnoLeftNavClassNames, getUnoLeftNavStyles } from "./UnoLeftNav.styles";
import { withTheme } from "@ms/uno-controls/lib/local/utilities/withTheme";
// Constants
import { ComponentNames } from "../../constants/ComponentNames";
/**
 * left nav component for rendering static section
 */ class UnoLeftNavStaticSectionInternal extends BaseComponent {
    /**
     * Name of this component. Used for usage logging.
     */ name() {
        return ComponentNames.UnoLeftNavStaticSection;
    }
    /**
     * Render the Uno leftNav static section
     */ renderComponent() {
        const { staticOptions } = this.props;
        const leftNavClassNames = this.getLeftNavClassNames();
        const className = css("list", "staticSection", leftNavClassNames.leftNavOptionsList);
        const optionsToRender = [
            staticOptions.myDayInfo,
            staticOptions.myTasksInfo,
            staticOptions.myPlansInfo
        ];
        if (staticOptions.myPortfoliosInfo) {
            optionsToRender.push(staticOptions.myPortfoliosInfo);
        }
        return /*#__PURE__*/ React.createElement(FocusZone, {
            direction: FocusZoneDirection.vertical
        }, /*#__PURE__*/ React.createElement("ul", {
            className: className,
            role: "menubar"
        }, optionsToRender.map((option)=>this.getLeftNavOptionFrom(option))));
    }
    /**
     * Get the classnames associated with the computed styles for the Uno leftNav
     */ getLeftNavClassNames() {
        return getUnoLeftNavClassNames(getUnoLeftNavStyles(this.props.isLeftNavCollapsed, this.props.theme, getRTL()));
    }
    /**
     * Method responsible for rendering the Uno leftNav option
     */ getLeftNavOptionFrom(optionInfo) {
        const { keyCodeMapper } = this.props;
        return /*#__PURE__*/ React.createElement(UnoLeftNavOption, {
            ...optionInfo,
            keyCodeMapper: keyCodeMapper
        });
    }
}
export const UnoLeftNavStaticSection = withTheme(UnoLeftNavStaticSectionInternal);
